var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/i18n/portuguese";
import "survey-core/i18n/portuguese";
import "survey-creator-core/survey-creator-core.min.css";
import { Grid } from "@mui/material";
import { setLicenseKey } from "survey-core";
import { Serializer } from "survey-core";
import RouterManager from "./modules/router/RouterManager";
import { configureGlobalPropertyGrid } from "./utils/survey-hidden-properties-grid-infos";
setLicenseKey(process.env.REACT_APP_SURVEYJS_LICENSE_KEY || "");
configureGlobalPropertyGrid(Serializer);
var App = function () {
    return (_jsx(Grid, __assign({ container: true, spacing: 1 }, { children: _jsx(Grid, __assign({ item: true, xs: 12, style: { paddingLeft: 0 } }, { children: _jsx(RouterManager, {}) })) })));
};
export default App;
